import { defineComponent as _defineComponent } from 'vue'
import { getDateRangeFormatted } from '@/services/date'
import { mdiDotsVertical } from '@mdi/js'
import { computed, ref } from 'vue'
// @ts-expect-error Not a ts file
import store from '@/store'
import { useImage } from '@/shared/composables/image'
import BKSvgIcon from '@/components/AppShared/BKSvgIcon.vue'
import { IEventPreview } from '@/enitites/event/model/types'
import { useRoute, useRouter } from 'vue-router/composables'
import IconLike from '@/shared/icons/IconLike.vue'
import ToggleLike from '@/features/toggle-like/ui/ToggleLike.vue'
import IconTier from '@/features/tickets/assets/IconTier.vue'
import MyTicketsInterface from '@/features/tickets/ui/MyTicketsInterface.vue'
import { ModalWrapper } from '@/shared/ui/modals'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileEventRow',
  props: {
    event: null
  },
  setup(__props: any) {

const props = __props as {
  event: IEventPreview
};

const { getEventImg } = useImage()



const router = useRouter()
const route = useRoute()
const getUserDB = computed(() => store.getters.getUserDB)

const isShowDeleteModal = ref(false)
const isShowTicketsModal = ref(false)
const isMyProfilePage = route.name === 'Profile' && Number(route.params.id) === getUserDB.value.id

const getEventDate = getDateRangeFormatted(props.event.dateStart, props.event.dateEnd)

const handleProvideFeedback = () => {
  router.push({
    name: 'Event',
    params: { id: `${props.event.id}` },
    query: { tab: 'feedback' },
  })
}

const handleReviewFeedback = () => {
  router.push({
    name: 'Event',
    params: { id: `${props.event.id}` },
    query: { tab: 'feedback' },
  })
}

return { __sfc: true,getEventImg, props, router, route, getUserDB, isShowDeleteModal, isShowTicketsModal, isMyProfilePage, getEventDate, handleProvideFeedback, handleReviewFeedback, mdiDotsVertical, BKSvgIcon, IconLike, ToggleLike, IconTier, MyTicketsInterface, ModalWrapper }
}

})